import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { IntegrationsPage } from "src/pages/IntegrationsPage";
import { integrationStatusesQueryOptions } from "src/queries/integrations";

const routeSearchSchema = z.object({
  strava: z.enum(["success", "error"]).optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/integrations/",
)({
  component: IntegrationsPage,
  validateSearch: routeSearchSchema,
  loader: async ({ context }) => {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...integrationStatusesQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
